export default {
  meta: {
    title: '模拟回复'
  }
};
